import PropTypes from 'prop-types';
import { Box, Flex, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import BroadcastItem from '../../../../campaigns/components/CampaignsTable/CalendarView/BroadcastItem.jsx';
import styles from '../../../../campaigns/components/CampaignsTable/CalendarView/CalendarView.module.css';

export default function BroadcastMonthCard({
  month,
  monthIndex,
  year,
  broadcasts = [],
  isCurrentMonth,
  isPastMonth,
  zIndex,
  hoveredBroadcast,
  onBroadcastHover,
  onBroadcastClick,
  onMonthClick,
}) {
  const { t } = useTranslation('broadcastMessages');

  // Sort broadcasts by date
  const sortedBroadcasts = [...broadcasts].sort((a, b) =>
    (a.displayDate || '').localeCompare(b.displayDate || ''),
  );

  const isModalOrDropdownClick = () => false;

  return (
    <Box
      className={`${styles.monthCard} ${
        isCurrentMonth ? styles.monthCardCurrent : ''
      } ${isPastMonth ? styles.monthCardPast : ''}`}
      style={{ zIndex }}
      role="region"
      aria-label={`${month} ${year}`}
      tabIndex={0}
    >
      <Box className={styles.monthHeader}>
        <Text
          className={`${styles.monthTitleText} ${styles.monthTitleClickable}`}
          size="5"
          weight="medium"
          onClick={() => onMonthClick && onMonthClick({ month, monthIndex })}
        >
          {month}
        </Text>
        <Flex className={styles.monthMeta} align="center">
          <Text size="1" className={styles.monthMetaText}>
            {year}
            {isCurrentMonth && ` • ${t('calendar.currentMonth')}`}
            {isPastMonth && ` • ${t('calendar.completed')}`}
          </Text>
        </Flex>
      </Box>
      <Box className={styles.dottedSeparator} />
      <Flex className={styles.campaignList} direction="column" as="ul">
        {sortedBroadcasts.map(broadcast => (
          <BroadcastItem
            key={`broadcast-${broadcast.uuid}`}
            broadcast={broadcast}
            hoveredBroadcast={hoveredBroadcast}
            onHover={onBroadcastHover}
            onClick={onBroadcastClick}
            isModalOrDropdownClick={isModalOrDropdownClick}
          />
        ))}
      </Flex>
    </Box>
  );
}

BroadcastMonthCard.propTypes = {
  broadcasts: PropTypes.array,
  hoveredBroadcast: PropTypes.string,
  isCurrentMonth: PropTypes.bool,
  isPastMonth: PropTypes.bool,
  month: PropTypes.string,
  monthIndex: PropTypes.number,
  onBroadcastClick: PropTypes.func,
  onBroadcastHover: PropTypes.func,
  onMonthClick: PropTypes.func,
  year: PropTypes.number,
  zIndex: PropTypes.number,
};
